import { memo } from 'react';
import { type ChipProps } from '@mui/material';
import { FunctionField, type FunctionFieldProps } from 'react-admin';
import { StatusChip } from './StatusChip';
import { EditorialAssetSearchResultItem } from 'utility/types/dataProvider';

// Re-export commonly used items from StatusChip for backwards compatibility
export { STATUS_TO_ICON, getStartTimeInFuture } from './StatusChip';

export type StatusFieldProps = Omit<FunctionFieldProps, 'render'> & {
  iconSize?: number;
  chipVariant?: ChipProps['variant'];
  tint?: number;
  sx?: any;
};

export const StatusField = memo(
  ({
    iconSize = 16,
    chipVariant = 'filled',
    tint = 0.12,
    sx,
    ...props
  }: StatusFieldProps) => {
    return (
      <FunctionField
        {...props}
        render={(record: EditorialAssetSearchResultItem) =>
          record ? (
            <StatusChip
              record={record}
              iconSize={iconSize}
              chipVariant={chipVariant}
              tint={tint}
            />
          ) : null
        }
      />
    );
  },
);
StatusField.displayName = 'StatusField';

export default StatusField;
